import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { internalCalendarEventsService } from '../api/internal-calendar-events.service';
import { EXTERNAL_CALENDAR_EVENTS_KEYS } from './queryKeys';

export function useDeleteCalendarEvent() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: (eventId: string) => internalCalendarEventsService.deleteEvent(eventId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: EXTERNAL_CALENDAR_EVENTS_KEYS.root(orgId ?? '') });
    },
  });
}
